var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultAvatarClicked = function SvgDefaultAvatarClicked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#004BFF",
    d: "M11.125.5C5.327.5.625 5.202.625 11s4.702 10.5 10.5 10.5 10.5-4.702 10.5-10.5S16.923.5 11.125.5m-5.25 8.367a1.125 1.125 0 0 1 2.25 0 1.125 1.125 0 0 1-2.25 0m5.25 6.375a3.76 3.76 0 0 1-3.75-3.553.19.19 0 0 1 .188-.197H8.69a.19.19 0 0 1 .19.174 2.252 2.252 0 0 0 4.49 0 .19.19 0 0 1 .19-.174h1.127a.19.19 0 0 1 .188.197 3.76 3.76 0 0 1-3.75 3.553m4.125-5.25a1.125 1.125 0 0 1 0-2.25 1.125 1.125 0 0 1 0 2.25"
  })));
};
export default SvgDefaultAvatarClicked;